import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { PersonIcon, ChartIcon } from "../icons";

const FEATURES = [
  {
    icon: "⊞",
    title: "Single & Double Elimination",
    text: "Generate clean brackets for any number of players, with byes handled automatically.",
  },
  {
    icon: "★",
    title: "Seeded by Rating",
    text: "Spread your top players across the bracket with Elo-based seeding, or shuffle at random.",
  },
  {
    icon: <ChartIcon />,
    title: "Rating History",
    text: "Track every player's Elo over time and compare them on an interactive graph.",
  },
  {
    icon: <PersonIcon />,
    title: "Player Records",
    text: "Keep a running history of wins, losses, and head-to-head results for every player.",
  },
];

function HomePage() {
  const { session } = useAuth();

  return (
    <div className="mk-home">
      <section className="mk-hero">
        <h1 className="mk-hero-title">Run better tournaments.</h1>
        <p className="mk-hero-sub">
          Tournament City makes it effortless to create brackets, track results,
          and follow your players' ratings over time — single or double
          elimination, seeded or random.
        </p>
        <div className="mk-hero-actions">
          <Link to={session ? "/app" : "/sign-in"} className="mk-btn-primary">
            {session ? "Open the App" : "Get Started — Free"}
          </Link>
          <Link to="/product" className="mk-btn-ghost">
            See features
          </Link>
        </div>
      </section>

      <section className="mk-features">
        {FEATURES.map((f) => (
          <div key={f.title} className="mk-feature">
            <span className="mk-feature-icon">{f.icon}</span>
            <h3 className="mk-feature-title">{f.title}</h3>
            <p className="mk-feature-text">{f.text}</p>
          </div>
        ))}
      </section>

      <section className="mk-cta">
        <h2 className="mk-cta-title">Ready to run your next tournament?</h2>
        <p className="mk-cta-sub">
          Create an account in seconds, or try it instantly as a guest.
        </p>
        <Link to={session ? "/app" : "/sign-in"} className="mk-btn-primary">
          {session ? "Open the App" : "Get Started"}
        </Link>
      </section>
    </div>
  );
}

export default HomePage;
